import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AppThemeProvider from "./theme/AppThemeProvider";
import { Provider } from "react-redux";
import store from "./store";
import ContextProvider from "./context/ContextProvider";
import "./i18n";

import "./index.scss";
import "./qpds";
// Yup always relies on the Promise global object to handle asynchronous
// values as well as Set and Map. For browsers that do not support these,
// you'll need to include a polyfill, such as core-js:
import "core-js/es/promise";
import "core-js/es/set";
import "core-js/es/map";
import { setAutoFreeze } from "immer";

const rootElement = document.getElementById("root");

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`);
  });
}

setAutoFreeze(false);

ReactDOM.render(
  <Provider store={store}>
    <AppThemeProvider>
      <ContextProvider>
        <App />
      </ContextProvider>
    </AppThemeProvider>
  </Provider>,
  rootElement
);
